import zepto from 'autocomplete.js/zepto';
export default zepto;
